import { CalendarComponent, CalendarPopover } from './components';

import './lib/Calendar.scss';

/**
 * @param {import('./lib/propTypes').CalendarProps} props
 */

const Calendar = (props) => {
  if (props.isPopover)
    return (
      <CalendarPopover {...props}>
        <CalendarComponent {...props} />
      </CalendarPopover>
    );
  return <CalendarComponent {...props} />;
};
export default Calendar;
